import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { JariValidators } from 'src/app/shared/shared/jari-validators';

@Component({
  selector: 'app-change-invited-user-password',
  templateUrl: './change-invited-user-password.component.html',
  styleUrls: ['./change-invited-user-password.component.css']
})
export class ChangeInvitedUserPasswordComponent {
  oldPassword!: string;
  newPassword!: string;
  confirmNewPassword!: string;
  validPasswordPattern = JariValidators.validPasswordRegex;
  hideOldPassword: boolean = false;
  hideNewPassword: boolean = false;
  hideConfirmNPassword: boolean = false;


  constructor(
    private userDataService: UserDataService,
    private notificationServie: NotificationService,
    private router: Router,
  ) { }

  isPasswordIdentical() {
    return this.newPassword && this.confirmNewPassword && this.newPassword.replaceAll(' ', '') == this.confirmNewPassword.replaceAll(' ', '');
  }
  changePassword(){
    this.userDataService.ChangePassword(this.oldPassword!,this.newPassword,this.confirmNewPassword).subscribe({
      next:(res)=>{
        this.notificationServie.success(res.data.message);
        this.router.navigate(['/kyc/kyc-questions']);
      },
      error:(error)=>{
        this.notificationServie.error(error?.error?.message)
      }
    })
  }
}
